import React from 'react';
import { InputFormGroup, LineByLineFormGroup } from '@bingads-webui-cc-react/layout';
import { ValidationGroup, Input } from '@bingads-webui-react/primitive-validation';
import { Constants, TaxUtils } from '@bingads-webui-clientcenter/entity-utils';
import { validateField, CustomValidateItems, ValidateItems } from '../validator';
import { TaxTypeFormPropTypes } from '../shapes';
import { InputTaxFieldId } from '../constants';
import { registerTaxform } from '../taxform-store';
import { withViewTaxFormWithFilledEmptyTaxValue, getTaxTypeLabel } from '../utils';
import { useValidationI18n } from '../hooks/use-i18n';

const { isSGGSTNumberValid } = TaxUtils;
const { TaxLabelFormat, TaxType } = Constants;

const isSGGSTNumberRequired = false;

const SGTaxSchema = {
  name: 'Singapore Taxation Validation Schema',
  type: 'object',
  properties: {
    [TaxType.GSTNumber]: {
      type: 'string',
      required: isSGGSTNumberRequired,
    },
  },
};

const SGTaxForm = ({
  i18n,
  alwaysShowError,
  data,
  disabled,
  onValidate,
  showLineByLineFormGroup,
}) => {
  const validationI18n = useValidationI18n(i18n);
  const CustomizedFormGroup = showLineByLineFormGroup ? LineByLineFormGroup : InputFormGroup;

  return (
    <ValidationGroup
      validationProps={{
        i18n: validationI18n,
        onValidate,
        data,
        schema: SGTaxSchema,
      }}
    >
      <CustomizedFormGroup
        isStatic
        label={getTaxTypeLabel(TaxType.GSTNumber, i18n, { labelFormat: TaxLabelFormat.RequiredForBusiness })}
      >
        <Input
          id={InputTaxFieldId(TaxType.GSTNumber)}
          validationProps={{
            field: TaxType.GSTNumber,
            validator: value => validateField(
              value,
              { [ValidateItems.Required]: { isRequired: isSGGSTNumberRequired } },
              { [CustomValidateItems.SGGSTNumberValidation]: inputValue => inputValue.length > 0 && !isSGGSTNumberValid(inputValue) },
              i18n
            ),
            alwaysShowError,
          }}
          disabled={disabled}
        />
      </CustomizedFormGroup>
    </ValidationGroup>
  );
};

SGTaxForm.propTypes = TaxTypeFormPropTypes;

registerTaxform('/SG/', SGTaxForm, withViewTaxFormWithFilledEmptyTaxValue({ getTaxSchema: () => SGTaxSchema }));
